import { InputGroup, Position, Tooltip } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { StandardFormInput } from "modules/common/components/form/StandardFormInput";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { getFieldLabel } from "modules/common/services/form/fields";
import { onlyDigitsInputKeyPress } from "modules/common/services/form/values";
import React from "react";
import { Schema } from "yup";
import { fields } from "../models/settings";
import styles from "./SystemSettings.module.scss";

const digits = onlyDigitsInputKeyPress(true);

/**
 * Параметры распределения накладных расходов по проектам:
 * фиксированная часть (минимальный порог от выручки) + переменная (по трудозатратам).
 */
const OverheadSettingsBase: React.FC<OverheadSettingsProps> = ({ schema }) => (
  <div className="columns">
    <div className={styles.columns}>
      <div className={styles.column}>
        <StandardFormInput
          name={fields.overheadDistributionEnabled}
          schema={schema}
          small={true}
          className="planr-form-input"
          inline={false}
        >
          {({ field, form }) => (
            <PlanrButton
              type="neutral"
              icon={field.value ? "general-checkbox" : "general-zero-checkbox"}
              onClick={() => {
                form.setFieldValue(field.name, !field.value);
                form.setFieldTouched(field.name, true);
              }}
              style={{ marginTop: "-5px" }}
            />
          )}
        </StandardFormInput>

        <StandardFormInput
          name={fields.overheadFixedShare}
          schema={schema}
          inline={false}
          small={true}
          className="planr-form-input"
          label={
            <span className="planr-input-label-help">
              {getFieldLabel(fields.overheadFixedShare, schema, null)} &nbsp;&nbsp;
              <Tooltip
                content={
                  <div style={{ maxWidth: "420px" }}>
                    <p>
                      Доля норматива накладных расходов, которая начисляется на любой активный проект от его выручки —
                      минимальный порог для проектов на субподряде.
                    </p>
                    <p>Остаток норматива распределяется пропорционально себестоимости собственного труда.</p>
                  </div>
                }
                position={Position.RIGHT}
              >
                <GeneralIcon type="general-question" />
              </Tooltip>
            </span>
          }
        >
          {({ field }) => (
            <InputGroup
              id={field.name}
              className="planr-default-input"
              {...field}
              onKeyPress={digits}
              autoComplete="off"
              data-lpignore="true"
            />
          )}
        </StandardFormInput>

        <StandardFormInput
          name={fields.overheadTaxShare}
          schema={schema}
          inline={false}
          small={true}
          className="planr-form-input"
        >
          {({ field }) => (
            <InputGroup
              id={field.name}
              className="planr-default-input"
              {...field}
              onKeyPress={digits}
              autoComplete="off"
              data-lpignore="true"
            />
          )}
        </StandardFormInput>

        <StandardFormInput
          name={fields.overheadPaymentShare}
          schema={schema}
          inline={false}
          small={true}
          className="planr-form-input"
        >
          {({ field }) => (
            <InputGroup
              id={field.name}
              className="planr-default-input"
              {...field}
              onKeyPress={digits}
              autoComplete="off"
              data-lpignore="true"
            />
          )}
        </StandardFormInput>
      </div>
    </div>
  </div>
);

export const OverheadSettings = observer(OverheadSettingsBase);

interface OverheadSettingsProps {
  schema: Schema<any>;
}
